import { adminHttpClient } from '../../../../commons/adminHttpClinet';
import { UpdateMarketplacePlatformModel } from './../../../../models/dashboard/marketplace/marketplaceModels';

 const updatePlatform = (platform: UpdateMarketplacePlatformModel ): Promise<any> => {
  return adminHttpClient.put("/api/Admin/AdminMarketplace/update-platform", platform);
};
export  default updatePlatform;